// extracted by mini-css-extract-plugin
export default {"root":"Routz","menu":"TAKMb","avatar":"JuWxx"};